import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from '../../common/withRouter';
import {
  Loader,
  ButtonOBSOLETED,
  Notification,
  Message,
} from "../../web.common";
import { LayoutContext } from "../layout/siteLayout";
import PageTop from "../layout/PageTop";
import withApi from "../higherOrderComponents/withApi";
import { DisplayGuid, DisplayType } from "../items";

const LockersInternal = (props) => {
  const [loadedData, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const clickable ={
    cursor: "pointer"
  }

  useEffect(() => {
    async function loadFromApi() {      
      loadData();
    }
    if (!loadedData) {
      loadFromApi();
    }
  },[]);

  const loadData = async () => {
    setIsLoading(false);

    const lockersResponse = await props.api.lockers.getLockers();

    if (lockersResponse.success) {
      setData(lockersResponse.data);
    }
    
    setIsLoading(true);
  };

  const deleteLocker = async (event, lockerId) => {
    event.stopPropagation();
    const response = await props.api.lockers.deleteLocker(lockerId);
    if (response && response.success === false) {
      alert(`The locker was not deleted. ${response.message || ''}`);
    }
    loadData();
  };

  const header = [
    {
      name: "Id",
      label: "Id",
      breakWord: false,
      render: ({ id }) => <DisplayGuid short>{id}</DisplayGuid>,
    },
    {
      name: "Facility",
      label: "Facility",
      breakWord: false,
      render: ({ facilityId, facilityName }) => <>{facilityName} - <DisplayGuid short>{facilityId}</DisplayGuid></>,
    },
    {
      name: "Name",
      label: "Name",
      breakWord: false,
      render: ({ name }) => <span>{name}</span>,
    },
    {
      name: "Type",
      label: "Type",
      breakWord: false,
      render: ({ lockerType }) => <DisplayType>{lockerType}</DisplayType>,
    },
    {
      name: "Action",
      label: "Action",
      render: ({ id }) => (
        <>
          <span>
            <button onClick={async (e) =>
              {if (!confirm('are you sure to delete this locker?')) {
                                return;
                              }
                await deleteLocker(e,id);
              }
            }>
              delete
            </button>
          </span> 
        </>
      ),
    },
  ];

  return (
    <LayoutContext.Consumer>
      {() => (
        <React.Fragment>
          {/* <Notification newMessage={errorMessage} /> */}
          <div className="content-with-right-pane-delimiter">
            <PageTop
              documentTitle="Lockers"
              documentDescription="Lockers"
            />
            <h2 className="main-page-header">Lockers</h2>
            {loadedData == null ? (
              <span>Loading...</span>
            ) : (
              <>
                <br />
                <div className="filters-submit-wrapper">
                  <ButtonOBSOLETED
                    onClick={async () => 
                      { 
                        props.history.push('/locker-create');
                      }}
                    type="submit"
                    buttonContent="New"
                    disabled={!isLoading}
                  />
                </div>
                <br />
                <article className="data-table-wrap">
                  <table className="data-lists component-data-table cell-content-align-top">
                    <thead>
                      <tr>
                        {header.map((property) => (
                          <td
                            style={property.canOrder ? clickable : null}
                            onClick={() =>
                              typeof property === "object"
                                ? property.label
                                : property
                            }
                          >
                            {typeof property === "object"
                              ? property.label
                              : property}
                          </td>
                        ))}
                      </tr>
                    </thead>
                    {loadedData.map((row) => (
                      <tbody>
                        <tr className="hover-listview "
                        onClick={() =>
                  props.history.push(`/locker/${row.id}`)
                }
                        >
                          {header.map((property) => (
                            <td style={ property.breakWord ? {overflowWrap: 'anywhere'} : {}}>
                              <strong className="table-cell-label">
                                {typeof property === "object"
                                  ? property.label
                                  : property}
                              </strong>
                              {typeof property === "object" ? (
                                property.render(row)
                              ) : (
                                <span>{row[property]}</span>
                              )}
                            </td>
                          ))}
                        </tr>
                      </tbody>
                    ))}
                  </table>
                </article>
              </>
            )}
          </div>
        </React.Fragment>
      )}
    </LayoutContext.Consumer>
  );
};

const Lockers = withRouter(
  withApi(
    connect(
      ({ user, categories }) => ({ isLoggedIn: !!user, categories }),
      {}
    )(LockersInternal)
  )
);

Lockers.requiresLogin = true;
Lockers.propTypes = { isLoggedIn: PropTypes.bool };

export default Lockers;
